<template>
    <div>
        <md-field>
            <label>{{labelText}}</label>
            <TbSelect v-model="selectedValues" md-dense multiple
					  :search-allow="true"
					  :options="options"
					  options-value-field="id"
					  options-display-field="displayValue"
					  ref="select"
			/>
        </md-field>
    </div>
</template>
<script>

export default {
    props: {
        fieldType: { type: String, default: "I" },
        labelText: { type: String },
        columnName: { type: String },
        enumDef: { type: Object },
		exclude: { type: Function, default: null },
        initialValues: { type: Array, default: [] }
    },
    data() {
        return {
            selectedValues: this.initialValues.map(value => String(value))
        };
    },
	computed: {
    	options() {
    		return Object.keys(this.enumDef.properties)
				.filter((value) => !this.exclude || !this.exclude(value))
				.map(enumValue => {
					return {
						id: enumValue,
						displayValue: this.$t(this.enumDef.properties[enumValue].key)
					};
			});
		}
	},
    methods: {
        clearFilter() {
            this.selectedValues = [];
            this.$refs.select.resetSearch();
        },
        getFilter() {
            if (this.selectedValues.length === 0) {
                return null;
            }

            return [{
                columnName: this.columnName,
                fieldType: this.fieldType,
                matchType: "IN",
                value: this.selectedValues.join(",")
            }];
        },
        setFilter(filter) {
            this.selectedValues = filter.value.split(",");
        }
    },
};
</script>
